import React, { useState, useEffect } from "react";
import Page1 from "../../components/RoofingReports/Page1";
import Page2 from "../../components/RoofingReports/Page2";
import Page3 from "../../components/RoofingReports/Page3";
import Page4 from "../../components/RoofingReports/Page4";
import Page5 from "../../components/RoofingReports/Page5";
import Page6 from "../../components/RoofingReports/Page6";
import HailPage from "../../components/RoofingReports/HailPage";
import { useRouter } from "../../util/router";
import PageLoader from "../../components/PageLoader";
import { useRoofingReportsData } from "../../util/hooks/useRoofingReportsData";
import AuthForm from "../../components/RoofingReports/AuthForm";
import KespryFrame from "../../components/RoofingReports/KespryFrame";
import { handleGetFormId } from "./helper";
import NoLeak from "../../components/RoofingReports/NoLeak";
import NextSteps from "../../components/RoofingReports/NextSteps";
import JotForm1 from "../../components/RoofingReports/Jotform1";
import queryString from "query-string";

const RoofingReport = ({ location: { search } }) => {
  const router = useRouter();

  const {
    match: {
      params: { reportId },
    },
  } = router;

  const [loading, setLoading] = useState(true);
  const [formData, setFormata] = useState(null);
  const [reportType, setReportType] = useState(null);
  const reportsData = useRoofingReportsData(reportId);

  useEffect(() => {
    const parsedQueryString = queryString.parse(search);
    const { reportDoc } = parsedQueryString;
    setReportType(reportDoc);
  }, [search]);

  useEffect(() => {
    reportsData && setLoading(false);
    reportsData &&
      handleGetFormId(
        setFormata,
        "team@remoteroofing.com",

        Number(reportType) === 2
          ? reportsData?.data?.document2id
          : reportsData?.data?.documentId
      );
  }, [reportsData]);

  return (
    <div
      className="mt-5"
      style={{
        maxWidth: "612px",
        width: "612px",
        margin: "auto",
        paddingBottom: "300px",
      }}
    >
      {loading ? (
        <PageLoader />
      ) : (
        <>
          <Page1
            background={reportsData?.data?.report_background[0]?.url}
            address={reportsData?.data?.address}
          />
          <Page2
            anomalies={reportsData?.data?.anomalies}
            wind_damage={reportsData?.data?.wind_damage}
            hail_detection={reportsData?.data?.hail_detections}
            buildingImg={reportsData?.data?.building_image[0]?.url}
          />
          {/* <Page3 /> */}
          <HailPage />
          <NoLeak />
          {/* <Page4 />
          <Page5 /> */}
          {/* <Page6 /> */}
          <NextSteps />
          <AuthForm formData={formData} />
          <JotForm1 />
          {/* <KespryFrame /> */}
        </>
      )}
    </div>
  );
};

export default RoofingReport;
